// src/components/SkeletonCard.jsx

import React from 'react';

const SkeletonCard = () => {
    return (
        <div className="animate-pulse flex-shrink-0 w-72 h-96 bg-gray-300 rounded-lg"></div>
    );
};

export default SkeletonCard;
